import { readClientEnv } from '@up2stay/up2promo-commons/env';

import { envSchema } from '../env.schema';

/** Validated public env; `vite build` has already rejected missing values. */
export const env = readClientEnv(envSchema, import.meta.env);
